import React from 'react'
import { Container } from 'react-bootstrap';

const Footer = () => {
  return (
    <div className='footer-section'>
        <Container fluid>
            <p>Made with <span style={{color: "rgb(247, 0, 0)", margin: "0px 0.5rem -1rem"}} >❤</span>by Makesh</p>
        </Container>
    </div>
  )
}

export default Footer;